import { useNavigate } from "react-router-dom"
import { useReleaseNotes } from "api/useReleaseNotes"
import useAuth0Metadata from "api/useAuth0Metadata"
import { useCustomerData } from "context/customer-provider"
import { hasUnseenReleases } from "pages/common/ReleaseNotes/releases"

const WhatsNewButton = () => {
    const navigate = useNavigate()
    // Release notes currently only cover roads features, so hide the What's New icon
    // (and its unseen-dot) for rail customers (NR/RAIL — product "rail"), same as the
    // roads-only notification prefs in NotificationBell.
    const { product } = useCustomerData()
    // Published notes only — the dot must reflect what a normal user would see, and the
    // list is sorted newest-first by the API.
    const { data: releaseNotes } = useReleaseNotes()
    // Newest-first paginated; the first note on the first page is the latest release.
    const latestReleaseDate = releaseNotes?.pages?.[0]?.[0]?.release_date

    // Seen-state lives in Auth0 user_metadata (releaseNotesLastSeen) so the dot follows the
    // account across browsers/devices — same approach as the driver.js guided tours. The
    // release notes page advances the marker on visit; the optimistic PATCH updates this
    // cached metadata, so the dot clears automatically without any local state. Wait for
    // the metadata fetch before deciding so the dot doesn't flash while it loads.
    const { userMetadata, isLoadingMetadata } = useAuth0Metadata()
    const showDot = !isLoadingMetadata && hasUnseenReleases(userMetadata?.releaseNotesLastSeen, latestReleaseDate)

    if (product === "rail") return null

    return (
        <li className="mr-2 lg:mr-0">
            <button
                type="button"
                className="p-link"
                title="What's New"
                onClick={() => navigate("/release-notes")}
                style={{ position: "relative", overflow: "visible", padding: 2 }}
            >
                <i className="pi pi-megaphone" style={{ fontSize: "1.2rem" }} />
                {showDot && (
                    <span
                        style={{
                            position: "absolute",
                            top: -1,
                            right: -1,
                            width: 9,
                            height: 9,
                            borderRadius: 999,
                            background: "#ef4444",
                            pointerEvents: "none",
                            zIndex: 1,
                        }}
                    />
                )}
            </button>
        </li>
    )
}

export default WhatsNewButton
